import React from 'react';
import axios from 'axios'; 

class Organization extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            brand: '',
            address: '',
            city: '', 
            state: '', 
            zip: ''
        }
    }

    cap = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    addOrganization = () => {
        if (this.state.formCode) {
            this.setState({
                formCode: Math.floor(Math.random() * 100000000)
            })
        }

        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.post(this.props.apiurl + '/api/organization/add', {
            userId: this.props.userdata.userId,
            name: this.state.formName,
            json: JSON.stringify(this.state),
            type: 'QR Code Form',
            status: 'active',
        }, {
            headers: headers
        }).then(res => {
            if (res.status === 200) {
                console.log(res);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    handleChangeName = (event) => {
        this.setState({
            name: this.cap(event.target.value)
        });
    }

    handleChangeAddress = (event) => {
        this.setState({
            address: this.cap(event.target.value)
        });
    }

    handleChangeCity = (event) => {
        this.setState({
            city: this.cap(event.target.value)
        });
    }

    handleChangeState = (event) => {
        this.setState({
            state: this.cap(event.target.value)
        });
    }

    handleChangeZip = (event) => {
        this.setState({
            zip: this.cap(event.target.value)
        });
    }

    render() {

        return (
            <div className="container">
                <div className="row mb-2">
                    <div className="col">
                        <h3>Add New Organization</h3>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        <div className="form-group">
                            <label>Name</label>
                            <input type="text" 
                                value={ this.state.name }
                                onChange={ this.handleChangeName } 
                                className="form-control" />
                        </div>
                        
                        <div className="form-group">
                            <label>Address</label>
                            <input type="text"
                                value={ this.state.address }
                                onChange={ this.handleChangeAddress }
                                className="form-control" />
                        </div>

                        <div className="form-group">
                            <label>City</label>
                            <input type="text" 
                                value={ this.state.city }
                                onChange={ this.handleChangeCity }
                                className="form-control" />
                        </div>

                        <div className="form-group">
                            <label>State</label>
                            <input type="text" 
                                value={ this.state.state }
                                onChange={ this.handleChangeState }
                                className="form-control" />
                        </div>

                        <div className="form-group">
                            <label>Zip</label>
                            <input type="text" 
                                value={ this.state.zip }
                                onChange={ this.handleChangeZip }
                                className="form-control" />
                        </div>

                        <button className="btn btn-outline-secondary" onClick={this.addOrganization}>Save</button>
                        <div style={{ height: "80px" }}></div>

                    </div>
                </div>
            </div>
        );
    }
}

export default Organization;